/* eslint-disable */
import format from 'date-fns/format';

/**
 * Returns the date only from a date string.
 * @param {string} date The date string
 * @param {string} formatString The format string
 * @param {any} options The options object
 * @returns {Date} Start of given date
 */
const dateOnly = (date, formatString = `YYYY-MM-DD`, options = {}) => format(date.split(`T`)[0], formatString, options);

export default dateOnly;
